import { render, staticRenderFns } from "./Sendy.vue?vue&type=template&id=363d4084&scoped=true&"
import script from "./Sendy.vue?vue&type=script&lang=js&"
export * from "./Sendy.vue?vue&type=script&lang=js&"
import style0 from "./Sendy.vue?vue&type=style&index=0&id=363d4084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d4084",
  null
  
)

export default component.exports